<template>
  <p data-test="enabled-via">
    <CheckCircleIcon
      size="lg"
      class="mr-2 text-success"
    />
    {{ enabledViaText }}
  </p>
</template>

<script>
import { CheckCircleIcon } from '@/components/icons/fontIcons';

export default {
  name: 'UserMfaEnabledVia',

  components: {
    CheckCircleIcon,
  },

  props: {
    type: {
      type: String,
      default: null,
    },
  },

  computed: {
    enabledViaText() {
      if (this.type === 'totp') {
        return this.$t('mfa.enabledViaTotp');
      }

      if (this.type === 'sms') {
        return this.$t('mfa.enabledViaSms');
      }

      return null;
    },
  },
};
</script>

<style scoped>

</style>
